import React from 'react';
import { Stack, StackItem } from '@domain-group/fe-blueprint-ui/layout';
import { Button } from '@domain-group/fe-blueprint-ui/button';
import { ExternalLinkIcon } from '@domain-group/fe-co-icon';
import RmaLogo from '../rma-logo';
import * as style from './style';
import { PROFILE_TIERS } from '../../../hero/constants';
import { useReviewsContext } from '../../../recommendations-enquiry-section';

export interface VendorFooterProps {
  onVendorRecoViewAll: () => void;
  profileUrl: string;
  onShowMoreClick?: () => void;
  hasMoreReviews?: boolean;
}

const RmaFooter: React.FC<VendorFooterProps> = ({
  onVendorRecoViewAll,
  profileUrl,
  onShowMoreClick,
  hasMoreReviews = false,
}) => {
  const onReviewAllClick = () => {
    onVendorRecoViewAll();
    window.open(profileUrl, '_blank');
  };

  const { profileTier } = useReviewsContext();
  const isPlatinum = profileTier === PROFILE_TIERS.platinum;
  const displayShowAllButton = hasMoreReviews && isPlatinum;
  return (
    <Stack
      horizontalAlign={{
        regular: 'space-between',
        compact: 'start',
      }}
      verticalAlign="center"
      vertical={{
        compact: true,
        regular: false,
      }}
      reverse={{
        regular: false,
        compact: true,
      }}
      gap="s"
    >
      <StackItem
        css={style.rmaContainer}
        align={{
          regular: 'end',
          compact: 'stretch',
        }}
      >
        <Stack
          horizontalAlign={{
            compact: 'space-between',
            regular: 'start',
          }}
        >
          <StackItem>Reviews provided by</StackItem>
          <StackItem css={style.rmaLogo}>
            <RmaLogo height={30} />
          </StackItem>
        </Stack>
      </StackItem>
      <StackItem
        grow={{
          regular: false,
          compact: true,
        }}
        css={style.showAllContainer}
      >
        {displayShowAllButton ? (
          <Button
            appearance="outline"
            onClick={onShowMoreClick}
            onAuxClick={onShowMoreClick}
            stretched
          >
            Show more reviews
          </Button>
        ) : (
          <Button
            appearance="link"
            onClick={onReviewAllClick}
            onAuxClick={onReviewAllClick}
            stretched
            iconPosition="right"
            icon={<ExternalLinkIcon />}
            css={style.viewAllButton}
          >
            View all reviews on Rate My Agent
          </Button>
        )}
      </StackItem>
    </Stack>
  );
};
export default RmaFooter;
